import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import CardAlumni from "./cardAlumni"
import { Row } from "react-bootstrap"


export default function PostDocAlumni() {
  const ALUMNI = useStaticQuery(graphql`
    query  {
  allStrapiAlumni(sort: {fields: Status, order: DESC}, filter: {Status: {eq: "postdocs"}}) {
    nodes {
      Description
      Email
      Name
      Status
      Url
    }
  }
}
  `)
  return (
    <>
      {ALUMNI.allStrapiAlumni.nodes.map((alumni, key) => {
        return (
          <CardAlumni alumni={alumni}/>
        )
      })}
    </>
  )


}